import { render, staticRenderFns } from "./TabelaValores.vue?vue&type=template&id=4684ea71"
import script from "./TabelaValores.vue?vue&type=script&lang=js"
export * from "./TabelaValores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports